import React from 'react';
import { connect } from 'react-redux';
import SidebarFooter from '../../components/SidebarFooter';
import { getVersion } from './SidebarFooterActions';

class SidebarFooterContainer extends React.Component {

  componentDidMount() {
    //this.props.dispatch(getVersion());
  }


  render() {
    //let version = this.props.version;
    return (<SidebarFooter />);
  }
}

function mapStateToProps(state) {

  return {
    version: state.version
  };
}

export default connect(mapStateToProps)(SidebarFooterContainer);


// WEBPACK FOOTER //
// ./src/containers/SidebarFooter/SidebarFooterContainer.js